(() => {
  // Prevent double-execution if this file is injected/loaded more than once
  if (window.__MBE_SCROLL_ANIMATIONS_INIT__) return;
  window.__MBE_SCROLL_ANIMATIONS_INIT__ = true;

  const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "m-scroll-trigger";
  const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "m-scroll-trigger--offscreen";
  const SCROLL_ANIMATION_CANCEL_CLASSNAME = "m-scroll-trigger--cancel";

  function updateElementVisibility(element, isVisible) {
    if (isVisible) {
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    } else {
      element.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  }

  function handleMobileChange(element) {
    // Avoid attaching duplicate listeners to the same element
    if (element.__mbeMobileListenersAdded) return;
    element.__mbeMobileListenersAdded = true;

    const removeTriggerClass = () => element.classList.remove(SCROLL_ANIMATION_TRIGGER_CLASSNAME);

    try {
      if (window.MinimogTheme?.config?.mqlMobile || element.dataset.type === "fixed") {
        removeTriggerClass();
      }
    } catch (e) {
      // If MinimogTheme isn't available for some reason, fail gracefully
    }

    document.addEventListener("matchMobile", removeTriggerClass);
    document.addEventListener("unmatchMobile", removeTriggerClass);
  }

  function onIntersection(entries, observerInstance) {
    entries.forEach((entry, index) => {
      const { isIntersecting, target } = entry;
      updateElementVisibility(target, isIntersecting);

      if (isIntersecting) {
        if (target.hasAttribute("data-cascade")) {
          target.setAttribute("style", `--animation-order: ${index};`);
        }
        observerInstance.unobserve(target);
      }

      if (target.classList.contains("m-sidebar")) {
        handleMobileChange(target);
      }
    });
  }

  // Reuse a single observer across potential reinits / design mode reloads
  if (!window.__MBE_SCROLL_ANIMATIONS_OBSERVER__) {
    window.__MBE_SCROLL_ANIMATIONS_OBSERVER__ = new IntersectionObserver(onIntersection, {
      rootMargin: "0px 0px -50px 0px",
    });
  }
  const observer = window.__MBE_SCROLL_ANIMATIONS_OBSERVER__;

  function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
    const elements = rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME);
    if (elements.length === 0 || isDesignModeEvent) return;

    Array.from(elements).forEach((element) => observer.observe(element));
  }

  // Run once on DOM ready (guard prevents double binding)
  document.addEventListener("DOMContentLoaded", () => initializeScrollAnimationTrigger());

  if (window.Shopify?.designMode) {
    const reinitialize = (event) => initializeScrollAnimationTrigger(event.target, true);
    document.addEventListener("shopify:section:load", reinitialize);
    document.addEventListener("shopify:section:reorder", () => initializeScrollAnimationTrigger(document, true));
  }
})();